<template>
    <aside class="cms-navigation bg-gray-100 text-base">
        <div class="p-4 space-y-4 sticky top-0 lg:top-20 overflow-y-auto max-h-[calc(100dvh-(--spacing(16)))]">
            <slot></slot>
            <CmsNavigationList v-if="navigation" :navigation :root />
        </div>
    </aside>
</template>
<script setup lang="ts">
const { navigation = null, root } = defineProps<{ navigation?: CMSNavItem[] | null; root: string }>();
</script>
<style>
.cms-navigation {
    li {
        ul {
            display: none;
            margin-left: calc(var(--spacing) * 4);
        }
        a {
            padding: calc(var(--spacing) * 2);
            display: block;
            border-left: 3px solid transparent;
        }
    }

    li.active > a {
        font-weight: bold;
    }

    li.active > ul {
        display: block;
    }

    div > ul > li.active > a {
        border-left-color: currentColor;
    }
}
</style>
